<template>
    <section class="content-left">
        <div class="chart-box chart-summary">
            <h3 class="chart-title">概览</h3>
            <div class="detail">
                <p>当前在线人数：<span style="color: #00E6FE">{{$parent.onlineNum.onlineCount}}</span> 人</p>
                <p>年新增人数：<span style="color: #ECB86D">{{countData.thisYear}}</span> 人</p>
                <p>平台用户总数：<span style="color: #FE9494">{{countData.total}}</span> 人</p>
            </div>
        </div>
        <div class="chart-box chart-credit">
            <h3 class="chart-title">学分排行榜</h3>

            <div class="chart-wrap">
                <div class="chart-map" ref="creditChart"></div>
                <div class="chart-table">
                    <div class="table-header">
                        <ul class="cell cell-striped">
                            <li class="rank">排名</li>
                            <li class="credit">学分</li>
                            <li class="org">机构</li>
                        </ul>
                    </div>
                    <div class="table-body" v-if="tableData.length">
                        <ul class="cell" v-for="(item, index) in tableData" :key="item.rank"
                            :class="{'cell-striped': (index+1)%2===0}">
                            <li class="rank">{{index+1}}</li>
                            <li class="credit">{{item.totalCredit}}</li>
                            <li class="org">{{item.orgName}}</li>
                        </ul>
                    </div>
                    <p class="nodata" v-else>
                        暂无数据
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                countData: {},
                tableData: [],
            }
        },

        mounted() {
            this.initCount()
            this.initCreditChart()
            this.initTable()
        },

        methods: {
            async initTable() {
                /**
                 * 现在的逻辑是查最外层组织机构的学分排名
                 */
                let res = await this.$api.getMonitorCreditOrgRank()
                this.tableData = res.package
            },

            async initCount() {
                let res = await this.$api.getMonitorCount()
                this.countData = res.package || {}
            },

            async initCreditChart() {
                this.creditChart = echarts.init(this.$refs.creditChart)

                this.creditChart.showLoading({
                    text: '',
                    maskColor: 'rgba(97,197,255,.1)',
                })

                let res = await this.$api.getMonitorCreditRank()
                let data = res.package.slice(0, 10)
                let nameArr = data.map(item => item.name)
                let valueArr = data.map(item => item.value)
                let maxArr = data.map(item => valueArr[0])

                this.creditChart.hideLoading()

                let option = {
                    baseOption: {
                        tooltip: {
                            trigger: 'item',
                            position: 'top',
                            formatter: ({name, dataIndex}) => {
                                return name + '：' + valueArr[dataIndex]
                            },
                            textStyle: {
                                fontSize: 12
                            },
                        },
                        grid: {
                            show: false,
                            left: -30,
                            right: 0,
                            bottom: '10%',
                            top: '10%',
                            containLabel: true
                        },
                        xAxis: {
                            data: nameArr,
                            axisTick: {
                                show: false
                            },
                            axisLine: {
                                show: false
                            },
                            axisLabel: {
                                interval: 0,
                                textStyle: {
                                    color: '#9FD7FF',
                                    fontSize: 13,
                                },
                                formatter: function (val) {
                                    return val.length > 5 ? val.substr(0, 4) + "..." : val;
                                }
                            },
                        },
                        yAxis: {
                            show: false,
                            axisLine: {
                                show: false
                            },
                            axisTick: {
                                show: false
                            },
                            splitLine: {
                                show: false
                            },
                        },
                        dataZoom: [
                            {
                                type: 'inside'
                            }
                        ],
                        series: [
                            {
                                type: 'bar',
                                name: '填充',
                                barWidth: 16,
                                itemStyle: {
                                    color: 'rgba(97,197,255,.3)',
                                    barBorderRadius: 10,
                                },
                                barGap: '-100%',
                                barCategoryGap: '40%',
                                data: maxArr,
                                animation: false,
                            },
                            {
                                type: 'bar',
                                name: '学分',
                                barWidth: 16,
                                itemStyle: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 0, 1,
                                        [
                                            {offset: 0, color: '#7DBDFF'},
                                            {offset: 1, color: '#186FFF'}
                                        ]
                                    ),
                                    barBorderRadius: 10,
                                },
                                data: valueArr
                            }
                        ]
                    },
                    media: [{
                        query: {
                            maxWidth: 350,
                        },
                        option: {
                            xAxis: {
                                axisLabel: {
                                    textStyle: {
                                        fontSize: 10
                                    }
                                }
                            },
                            grid: {
                                bottom: '15%',
                                containLabel: true
                            },
                            series: [
                                {
                                    barWidth: 10,
                                },
                                {
                                    barWidth: 10,
                                }
                            ]
                        }
                    }]
                }

                this.creditChart.setOption(option)
            },

            resizeChart() {
                this.creditChart.resize()
            },

        },
    }
</script>

<style lang="scss">
    @import "~@/style/const";

    .m-monitorScreen {
        .content-left {
            //flex: 2;
            display: flex;
            flex-direction: column;
            width: 46vh;
        }

        .chart-summary {
            margin-bottom: 1vh;
            flex: 1;
            display: flex;

            .detail {
                display: flex;
                flex-direction: column;
                flex: 1;
                justify-content: center;
                padding: .2rem 0 0 .4rem;

                p {
                    padding: 10px;
                    font-size: .24rem;
                    letter-spacing: 1px;

                    span {
                        font-size: .32rem;
                        font-weight: 600;
                    }
                }
            }
        }

        .chart-credit {
            flex: 2;
            margin-bottom: 1vh;
            background-image: url(~@/assets/images/monitor/box-bg2.png)!important;

            .chart-wrap {
                height: 100%;
                padding: 50px 30px 20px 30px;
            }

            .chart-map {
                height: 40%!important;
            }

            .chart-table {
                position: relative;
                height: 60%;
            }

            .nodata {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 15px;
                letter-spacing: 1px;
            }
        }

        .chart-table {
            padding: 10px 0;

            .table-header {
                padding-right: 4px;
                font-weight: 600;
            }
            .table-body {
                height: calc(100% - 32px);
                padding-right: 4px;
                overflow: auto;
            }

            .cell {
                display: flex;
                height: 32px;
                line-height: 32px;
                font-size: .16rem;
                color: #E9EBFC;
                li {
                    padding: 0 10px;
                    text-align: center;
                }
                .rank {
                    width: 20%;
                }

                .credit {
                    width: 40%;
                }

                .org {
                    width: 40%;
                }
            }

            .cell-striped {
                background: rgba(0, 163, 239, .3);
                border-radius: 17px;
            }
        }

    }
</style>
